module.exports = __webpack_public_path__ + "static/img/item-7-1.9b9bce6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-7-1.png
// module id = MfCp
// module chunks = 2